// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__cA7BS","cell":"ColumnAccessor_cell__ha4dq","firstCellAccent":"ColumnAccessor_firstCellAccent__1hksO"};